const doc = [({"zh_tw":({"adminConstantInventoryUnit":({"guest":"客人增加/減少", "room":"房間增加/減少"})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;